import React from 'react'
import DisplayExitCompany from '../components/Companyes/DisplayExitCompany'

export default function CompanyesExit() {
  return (


    <div className="layout-body">
      <div className='row'>
        <div className='col-md-12'>
      <DisplayExitCompany />


        </div>
      </div>
    </div>
  )
}
